import { render, staticRenderFns } from "./up-policy-table.vue?vue&type=template&id=5fbe2789&scoped=true&"
import script from "./up-policy-table.vue?vue&type=script&lang=js&"
export * from "./up-policy-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbe2789",
  null
  
)

export default component.exports